import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle2, ExternalLink, XCircle } from 'lucide-react';
import { SharePointOAuthSettings } from '../../../components/SharePointOAuthSettings';
export function SharePointSettings({ connection, sites, onConnect, onDisconnect, oauthError }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-8",
        children: [
            oauthError && /*#__PURE__*/ _jsx("div", {
                className: "p-4 bg-danger-muted border border-danger rounded-lg",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "text-sm text-danger",
                    children: oauthError
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(SharePointOAuthSettings, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-lg font-medium text-foreground mb-4",
                        children: "Site Access"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-muted-foreground mb-6",
                        children: "Connect your SharePoint account to access and search documents with automatic permission filtering."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "bg-muted rounded-lg p-6 mb-6",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center space-x-3",
                                    children: [
                                        connection.connected ? /*#__PURE__*/ _jsx(CheckCircle2, {
                                            className: "w-6 h-6 text-success"
                                        }) : /*#__PURE__*/ _jsx(XCircle, {
                                            className: "w-6 h-6 text-muted-foreground"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("h4", {
                                                    className: "text-sm font-medium text-foreground",
                                                    children: connection.connected ? 'Connected to SharePoint' : 'Not Connected'
                                                }),
                                                connection.connected && connection.email && /*#__PURE__*/ _jsx("p", {
                                                    className: "text-sm text-muted-foreground",
                                                    children: connection.email
                                                }),
                                                connection.lastConnected && /*#__PURE__*/ _jsxs("p", {
                                                    className: "text-xs text-muted-foreground mt-1",
                                                    children: [
                                                        "Last connected: ",
                                                        new Date(connection.lastConnected).toLocaleString()
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: connection.connected ? /*#__PURE__*/ _jsx("button", {
                                        onClick: onDisconnect,
                                        className: "px-4 py-2 border border-danger text-danger rounded-md hover:bg-danger-muted transition-colors text-sm font-medium",
                                        children: "Disconnect"
                                    }) : /*#__PURE__*/ _jsx("button", {
                                        onClick: onConnect,
                                        className: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors text-sm font-medium",
                                        children: "Connect SharePoint"
                                    })
                                })
                            ]
                        })
                    }),
                    connection.connected && sites.length > 0 && /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs("h4", {
                                className: "text-md font-medium text-foreground mb-4",
                                children: [
                                    "Accessible Sites (",
                                    sites.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "space-y-3",
                                children: sites.map((site)=>/*#__PURE__*/ _jsx("div", {
                                        className: "bg-card border border-border rounded-lg p-4 hover:shadow-sm transition-shadow",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-start justify-between",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "flex items-center space-x-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("h5", {
                                                                    className: "text-sm font-medium text-foreground",
                                                                    children: site.site_name
                                                                }),
                                                                site.permission_level && /*#__PURE__*/ _jsx("span", {
                                                                    className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-info-muted text-info",
                                                                    children: site.permission_level
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "text-xs text-muted-foreground mt-1",
                                                            children: site.site_url
                                                        }),
                                                        site.roles && site.roles.length > 0 && /*#__PURE__*/ _jsx("div", {
                                                            className: "flex items-center gap-1 mt-2",
                                                            children: site.roles.map((role)=>/*#__PURE__*/ _jsx("span", {
                                                                    className: "inline-flex items-center px-1.5 py-0.5 rounded text-xs bg-muted text-muted-foreground",
                                                                    children: role
                                                                }, role))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: site.site_url,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "ml-4 p-1.5 text-muted-foreground hover:text-info transition-colors",
                                                    title: "Open in SharePoint",
                                                    children: /*#__PURE__*/ _jsx(ExternalLink, {
                                                        className: "w-4 h-4"
                                                    })
                                                })
                                            ]
                                        })
                                    }, site.site_id))
                            })
                        ]
                    }),
                    connection.connected && sites.length === 0 && /*#__PURE__*/ _jsxs("div", {
                        className: "text-center py-8 text-muted-foreground",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm",
                                children: "No SharePoint sites found for your account."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs text-muted-foreground mt-1",
                                children: "Sites will appear here based on your Microsoft 365 permissions."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mt-6 bg-info-muted border border-info rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ _jsx("h5", {
                                className: "text-sm font-medium text-info mb-2",
                                children: "About SharePoint Integration"
                            }),
                            /*#__PURE__*/ _jsxs("ul", {
                                className: "text-sm text-info space-y-1 list-disc list-inside",
                                children: [
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Documents are filtered based on your SharePoint permissions"
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Only documents you have access to will appear in search results"
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Sites listed above are determined by your Microsoft 365 access"
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Use the SharePoint Documents page to browse and search files"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
